import { createSelector } from "@ngrx/store";
import { AppState } from "../../app.state";

export const selectFormasEnvioState = ( state: AppState ) => state.formasEnvio;
export const selectFormasEnvio = createSelector(selectFormasEnvioState, (state) => state);